import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, FontWeights, Text, units } from '@calm-web/design-system';

import Image from '@/components/image/NextImage';

const PERSON_IMAGE_DIMENSION = 52;

export const Wrapper = styled.div`
	display: flex;
	gap: ${units(1.5)};
`;

export const PersonInfoWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${units(0.5)};
`;

export const PersonImage = styled(Image).attrs({
	layout: 'fixed',
	width: PERSON_IMAGE_DIMENSION,
	height: PERSON_IMAGE_DIMENSION,
})`
	border-radius: 50%;
`;

export const PersonName = styled(Text).attrs({
	color: 'white',
	weight: FontWeights.Demi,
	size: FontSizes.base,
})``;

export const PersonBio = styled(Text).attrs({
	color: 'whiteAlpha60',
	size: FontSizes.sm,
	weight: FontWeights.Medium,
})``;

export const AvatarIcon = styled.svg`
	border-radius: 26px;
	background: ${palette('blackAlpha20')};
	height: ${PERSON_IMAGE_DIMENSION}px;
	width: ${PERSON_IMAGE_DIMENSION}px;
	flex-shrink: 0;

	path {
		fill: ${palette('whiteAlpha20')};
	}
`;
